type SectionTitleProps = {
  title: string | React.ReactNode;
  color?: string;
  className?: string;
};

const SectionTitle = ({ title, color, className }: SectionTitleProps) => {
  return (
    <h2 className={`text-[4.2rem] font-bold leading-[1.1] ${color ?? ""} ${className ?? ""}`}>
      {title}
    </h2>
  );
};

export default SectionTitle;
